import { request } from '../request'

/**
 * 生成群发记录
 * @param data
 * @return {Promise}
 */
export function createSmsRecord(data) {
  return request({
    url: '/answer/sms/newRecord',
    method: 'post',
    data
  })
}

export function generateRecordInfo(data) {
  return request({
    url: '/answer/sms/generateRecordInfo',
    method: 'post',
    data
  })
}

/**
 * 查询已发短信
 * @param params
 * @return {Promise}
 */
export function getSmsMessage(params) {
  // params.surveyId="QUcsCYsd"
  return request({
    url: '/answer/sms/message/page',
    method: 'get',
    params
  })
}

export function getSmsRecord(params) {
  return request({
    url: '/answer/sms/record/page',
    method: 'get',
    params
  })
}

/**
 * 获取退款信息
 * @param id 群发记录id
 * @return {Promise}
 */
export function getClearSmsInfo(id) {
  return request({
    url: '/award/wjpayaccountrecord/clearForSms',
    params: {
      id
    },
    method: 'get'
  })
}

/**
 * 确认退款
 * @param id 群发记录 id
 * @return {Promise}
 */
export function confirmClearSms(id) {
  return request({
    url: '/award/wjpayaccountrecord/clearForSms',
    params: {
      id: id.toString()
    },
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/** 再次发送
 * @param id 群发记录 id
 * @return {Promise}
 */
export function resend(id) {
  return request({
    url: '/answer/sms/resendBatch',
    params: {
      id
    },
    method: 'get'
  })
}

/** 批次编号
 * @param surveyId 问卷 id
 * @return {Promise}
 */
 export function getBatchNo(surveyId) {
  return request({
    url: '/answer/sms/record/batchNumbers',
    params: {
      surveyId
    },
    method: 'get'
  })
}

/** 导出发送记录为Excel
 * @param surveyId
 * @return {Promise}
 */
export function exportExcel(params) {
  return request({
    url: '/answer/sms/exportMessageToExcel',
    params,
    method: 'get'
  })
}

/** 导出勾选项发送记录为Excel
 * @param surveyId
 * @param messageIds
 * @return {Promise}
 */
 export function exportExcelByChecks(data) {
  const { surveyId = '', messageIds = [] } = data || {};
  return request({
    url: `/answer/sms/exportMessageToExcelByIds?surveyId=${surveyId}`,
    method: 'post',
    data: messageIds,
  })
}


/**
 * 创建或修改短信额度审核
 * @param data
 * @returns {Promise}
 */
export function updateSmsAudit(data) {
  return request.post('/award/sms/editAudit', data)
}

/**
 * @returns {Promise}
 */
export function getSmsFinalAuditors(){
  return request.post('/wjsettlement/settleAuditorConfig/info',{
    types:[2]
  })
}


export function getSmsAudit(id){
  return request.get(`/award/sms/getLastAuditBySurveyId/${id}`)
}


export function closeAudit(id){
  return request.get(`/award/sms/closeAudit/${id}`)
}
